export default __webpack_public_path__ + "static/media/img-top-spedd-bg.226deb39.svg";